import React, { useEffect } from "react";
import { Link, withRouter } from "react-router-dom"
import { Col, Container, Row } from "reactstrap"
import { map } from "lodash"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import Card
import CardUser from "./card-user"

//redux
import { useSelector, useDispatch } from "react-redux";

import { getAdmins as onGetUsers } from "../../store/admins/actions"

const UsersGrid = () => {

  //meta title
  document.title="User Grid | Skote - React Admin & Dashboard Template";

  const dispatch = useDispatch()

  const { users } = useSelector(state => ({
    users: state.users.users,
  }))

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetUsers())
    }
  }, [dispatch, users])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Users" breadcrumbItem="User Grid" />

          <Row>
            {map(users, (user, key) => (
              <CardUser user={user} key={"_user_" + key} />
            ))}
          </Row>

          <Row>
            <Col xs="12">
              <div className="text-center my-3">
                <Link to="#" className="text-success">
                  <i className="bx bx-hourglass bx-spin me-2" />
                  Load more
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UsersGrid)
